<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">About Us</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>About Us</li>
            </ul>
        </div>
    </div>
</div>

<div class="about-area space-extra-bottom my-auto my-md-5 mb-a position-relative overflow-hidden overflow-hidden space"
    id="about-sec">
    <div class="container">
        <div class="row gy-4">
            <div class="col-xl-6">
                <div class="about10 img-box10 position-relative">
                    <div class="img1 bg-mask" data-mask-src="assets/img/shape/about_9_1_shape.png">
                        <img src="assets/img/normal/about_9_1.jpg" alt="About">
                    </div>
                    <div class="img2 bg-mask" data-mask-src="assets/img/shape/about_9_2_shape.png">
                        <img src=" assets/img/normal/about_9_2.jpg" alt="About">
                    </div>
                </div>
            </div>
            <div class="col-xl-6">
                <div class="ps-xxl-5 ms-xxl-4">
                    <div class="title-area about10-titlebox mb-20">
                        <span class="sub-title style1  text-anime-style-2">About Us</span>
                        <h2 class="sec-title mb-20 heading  text-anime-style-3">Unlocking Potential with Tailored IT
                            Solutions</h2>
                        <p class="sec-text mb-30 wow fadeInUp" data-wow-delay=".2s">IT Solutions encompass a wide range
                            of services, technologies, and
                            strategies designed to address the technological needs of businesses and organizations.
                            These solutions are tailored to improve efficiency, enhance productivity, ensure security,
                            and drive innovation.</p>
                    </div>
                    <div class="about10-item-wrap">
                        <div class="about-item wow fadeInUp" data-wow-delay=".3s">
                            <div class="about-item_img">
                                <img src="assets/img/icon/shield.svg" alt="">
                            </div>
                            <div class="about-item_centent">
                                <h5 class="box-title">Increased Efficiency</h5>
                                <p class="about-item_text">Automating repetitive tasks and streamlining workflows to
                                    save time and resources.</p>
                            </div>
                        </div>
                        <div class="about-item wow fadeInUp" data-wow-delay=".4s">
                            <div class="about-item_img"><img src="assets/img/icon/shield.svg" alt=""></div>
                            <div class="about-item_centent">
                                <h5 class="box-title">Competitive Advantage</h5>
                                <p class="about-item_text">Leveraging cutting-edge technology to stay ahead in the
                                    market.</p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-35 wow fadeInUp" data-wow-delay=".5s">
                        <a routerLink="/contact" class="th-btn th-radius th-icon">
                            Learn More <i class="fa-light fa-arrow-right-long"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="shape-mockup about-shape movingX d-none d-xxl-block" data-bottom="0%" data-right="-11%">
            <img src="assets/img/normal/about-slide-img.png" alt="shape">
        </div>
    </div>
</div>

<!--======== Customer Service Strip Section ========-->
<div class="about-area">
    <div style="background: var(--smoke-color);">
        <app-customer-service-strip></app-customer-service-strip>
    </div>
</div>
<!--======== Our Mission / Vision Section ========-->
<div class="history-sec1 overflow-hidden space" id="story-sec">
    <div class="container">
        <div class="row gy-4 justify-content-center">
            <div class="col-xl-4 col-md-6">
                <div class="story-box inner-style">
                    <span class="story-box_icon">
                        <img src="assets/img/icon/history_1_3.svg" alt="">
                    </span>
                    <h3 class="box-title">Who We Are</h3>
                    <p class="story-box_text mb-0">Xipe Tech is a Technological solutions company providing the best
                        kind of IT services for your business with utmost professionalism. Here in Xipe Tech, the
                        satisfaction of our customers is our main objective and everything else becomes secondary.</p>
                    <div class="checklist tick-checklist mb-40">
                        <ul>
                            <li>Planning and Requirement Gathering</li>
                            <li>UX/UI Design</li>
                            <li>Development</li>
                            <li>Maintenance and Updates</li>
                            <li>Search Engine Optimization</li>
                        </ul>
                    </div>

                </div>
            </div>
            <div class="col-xl-4 col-md-6">
                <div class="story-box inner-style">
                    <span class="story-box_icon">
                        <img src="assets/img/icon/history_1_1.svg" alt="">
                    </span>
                    <h3 class="box-title">Our Mission</h3>
                    <p class="story-box_text mb-0">Our core mission is to empower our clients' success through the
                        creation of compelling brand identities, immersive digital experiences, and impactful print
                        materials.</p>
                    <div class="checklist tick-checklist mb-40">
                        <ul>
                            <li>Deliver Results</li>
                            <li>Foster Innovation</li>
                            <li>Provide Exceptional Service</li>
                            <li>Empower Businesses</li>
                            <li>Foster Collaboration</li>
                            <li>Make a Positive Impact</li>
                        </ul>
                    </div>

                </div>
            </div>

            <div class="col-xl-4 col-md-6">
                <div class="story-box inner-style">
                    <span class="story-box_icon">
                        <img src="assets/img/icon/history_1_2.svg" alt="">
                    </span>
                    <h3 class="box-title">Our Vision</h3>
                    <p class="story-box_text mb-0">At Xipe Tech, our vision is to be a leading provider of innovative IT
                        solutions that transform businesses and shape the future of technology. We envision a world
                        where organizations harness the full potential of technology to achieve unprecedented growth,
                        efficiency, and success.</p>
                    <div class="checklist tick-checklist mb-40">
                        <ul>
                            <li>Drive Digital Transformation</li>
                            <li>Inspire Innovation</li>
                            <li>Empower Businesses</li>
                            <li>Foster Collaboration</li>
                            <li>Make a Positive Impact</li>
                            <li>Build Trusted Relationships</li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>


<!--======== Count Area Section ========-->
<div class="counter-sec2 space-bottom">
    <div class="container">
        <div class="row gy-4 align-items-center justify-content-center">

            <div class="col-md-6 col-xl-3">
                <div class="counter-card style3">
                    <div class="counter-shape"><span></span></div>
                    <div class="media-body">
                        <h3 class="box-number">
                            <span class="counter-number">12</span>
                        </h3>
                        <h6 class="counter-title">Years Experience</h6>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-xl-3">
                <div class="counter-card style3">
                    <div class="counter-shape"><span></span></div>
                    <div class="media-body">
                        <h3 class="box-number">
                            <span class="counter-number">97</span>%
                        </h3>
                        <h6 class="counter-title">Retention Rate</h6>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-xl-3">
                <div class="counter-card style3">
                    <div class="counter-shape"><span></span></div>
                    <div class="media-body">
                        <h3 class="box-number">
                            <span class="counter-number">654</span>+
                        </h3>
                        <h6 class="counter-title">Project Completed</h6>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-xl-3">
                <div class="counter-card style3">
                    <div class="counter-shape"><span></span></div>
                    <div class="media-body">
                        <h3 class="box-number">
                            <span class="counter-number">5</span>m
                        </h3>
                        <h6 class="counter-title">Audience Reach</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="shape-mockup jump d-none d-xl-block" data-bottom="20%" data-left="5%">
        <img src="assets/img/shape/shape_5.png" alt="shape">
    </div>
</div>

<!--======== Testimonial Section ========-->
<app-testimonial></app-testimonial>

<!--======== Footer Section ========-->
<app-footer></app-footer>